/* eslint-disable react/no-array-index-key */
import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ConcurrentsState } from 'store/modules/concurrents_store/types';
import Loader from 'components/atoms/loader';

interface ParticipationModalProps {
  show: boolean;
  onHide: () => void;
}

const ParticipationModal = ({ show, onHide }: ParticipationModalProps) => {
  const { concurrents, request } = useSelector<ApplicationState, ConcurrentsState>(
    (state) => state.session.concurrents,
  );

  return (
    <Modal show={show} onHide={onHide} size="lg" scrollable>
      <Modal.Header>
        <Modal.Title>Participações em empresas</Modal.Title>
        <button type="button" className="close" aria-label="Close" onClick={() => onHide()}>
          <span aria-hidden="true">&times;</span>
        </button>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
        {request?.membership_company?.loading ? (
          <Loader />
        ) : (
          <div id="participationAccordion" className="mt-3">
            {concurrents?.membership?.map((company, index) => (
              <div className="card mb-2" key={index}>
                <div
                  className="card-header d-flex justify-content-between align-items-center"
                  id={`participation-heading-${index}`}
                >
                  <button
                    type="button"
                    className="btn btn-link text-primary font-weight-bold text-left p-0"
                    style={{ textDecoration: 'none', fontSize: '1rem' }}
                    data-toggle="collapse"
                    data-target={`#participation-collapse-${index}`}
                    aria-expanded="false"
                    aria-controls={`participation-collapse-${index}`}
                  >
                    {company?.name}
                  </button>
                  <span style={{ fontSize: '0.95rem' }}>
                    <strong>CNPJ vinculados:</strong> {company?.companies?.empresas?.length || 0}
                  </span>
                </div>

                <div
                  id={`participation-collapse-${index}`}
                  className="collapse"
                  aria-labelledby={`participation-heading-${index}`}
                  data-parent="#participationAccordion"
                >
                  <div className="card-body" style={{ fontSize: '0.95rem' }}>
                    {company?.companies?.empresas?.map((empresa: any, i: number) => (
                      <div key={i} className="mb-3">
                        <p className="mb-1">
                          <strong>Razão Social:</strong> {empresa?.razao_social || 'Não informado'}
                        </p>
                        <p className="mb-2">
                          <strong>Vínculo:</strong>{' '}
                          {empresa?.quadro_socios_administradores?.[0]?.descricao_vinculo ||
                            'Não informado'}
                        </p>
                        {i < company.companies.empresas.length - 1 && <hr className="my-2" />}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ParticipationModal;
